import * as CryptoJS from 'crypto-js';
const AuthTokenKey = CryptoJS.enc.Utf8.parse('02daf79adc5c44ac'); //AES密钥

/*AES加密*/
export function Encrypt(data: unknown): string {
  if (!data) {
    console.error('参数不能为空');
    return '';
  }
  const dataStr = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(dataStr, AuthTokenKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

/*AES解密*/
export function Decrypt(data: string): string {
  if (!data) {
    console.error('参数不能为空');
    return '';
  }
  const decrypted = CryptoJS.AES.decrypt(data, AuthTokenKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypted).toString();
}
